import TherapistList from '@/modules/user/therapist/components/List'
import UserDashboardLayout
  from '@/modules/user/client/components/UserDashboardLayout'
import canViewTherapists from './hooks/canViewTherapists'
import canViewTherapist from './hooks/canViewTherapist'
import Profile from '@/modules/user/therapist/profile/Profile'

export default [
  {
    path: '/users',
    component: UserDashboardLayout,
    children: [
      {
        path: 'therapists',
        name: 'therapist',
        component: TherapistList,
        beforeEnter: canViewTherapists,
      },
      {
        path: 'therapists/:therapistId/edit',
        name: 'therapist-edit',
        component: Profile,
        props: true,
        beforeEnter: canViewTherapist,
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/modules/user/therapist/routes/index.js